import { Dialog } from "@mui/material";
import BasicDialogTitle from "../../../UI/BasicDialog/BasicDialogTitle";
import BasicDialogContent from "../../../UI/BasicDialog/BasicDialogContent";
import BasicDialogActions from "../../../UI/BasicDialog/BasicDialogActions";
import RequestSummary from "./Components/RequestSummary";
import Keep from "./Components/Keep";
import Reset from "./Components/Reset";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../store/slices/UI";

const UIText = {
  "es-CL":
    "Comenzar una solicitud de recuperación nueva o continuar con la existente?",
  "en-US": "Start a new recovery request or continue with the existing one?",
};

const ResetRequest = () => {
  const { dispatch, settings } = useUIBp();
  const header = UIText[settings.locale];

  const onClose = (e, reason) => {
    if (reason !== "backdropClick") {
      dispatch(UIactions.closeModal());
    }
  };

  return (
    <Dialog fullWidth {...{ open: true, onClose, maxWidth: "sm" }}>
      <BasicDialogTitle {...{ header }} />
      <BasicDialogContent>
        <RequestSummary />
      </BasicDialogContent>
      <BasicDialogActions>
        <Reset />
        <Keep />
      </BasicDialogActions>
    </Dialog>
  );
};

export default ResetRequest;
